import { useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;
export const CORES_PADRAO = { primaria: "#0A1B4D", acento: "#007BFF" };
export const FUNDO_PADRAO = "#000617";
const PADRAO = { cores: CORES_PADRAO, imagens: {}, versao: 0, personalizado: false, fundo_entrada: FUNDO_PADRAO };
let estado = PADRAO;
let carregando = null;
const subs = new Set();

export function hexParaHsl(hex, dl = 0) {
  const m = /^#?([0-9a-f]{6})$/i.exec(hex || "");
  if (!m) return null;
  const n = parseInt(m[1], 16);
  const r = ((n >> 16) & 255) / 255, g = ((n >> 8) & 255) / 255, b = (n & 255) / 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  let h = 0, s = 0;
  const l = (max + min) / 2;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    if (max === r) h = (g - b) / d + (g < b ? 6 : 0);
    else if (max === g) h = (b - r) / d + 2;
    else h = (r - g) / d + 4;
    h *= 60;
  }
  return `${Math.round(h)} ${Math.round(s * 100)}% ${Math.max(0, Math.min(100, Math.round(l * 100) + dl))}%`;
}

export function aplicarCores(cores) {
  const c = { ...CORES_PADRAO, ...(cores || {}) };
  const r = document.documentElement.style;
  const p = hexParaHsl(c.primaria), a = hexParaHsl(c.acento);
  if (p) { r.setProperty("--primary", p); r.setProperty("--onyx", c.primaria); }
  if (a) { ["--accent", "--gold", "--ring"].forEach((k) => r.setProperty(k, a)); r.setProperty("--gold-hover", hexParaHsl(c.acento, -8)); }
}

export const urlArquivo = (tipo, v) => `${API}/api/identidade/arquivo/${tipo}?v=${v || 0}`;

function aplicarFavicon(s) {
  document.documentElement.style.setProperty("--fundo-marca", s.fundo_entrada || FUNDO_PADRAO);
  if (!s.imagens?.icone) return;
  document.querySelectorAll("link[rel~='icon']").forEach((l) => { l.href = urlArquivo("icone", s.versao); });
  document.querySelectorAll("link[rel='apple-touch-icon']").forEach((l) => { l.href = `${API}/api/identidade/icone/180.png?v=${s.versao}`; });
  const m = document.querySelector("link[rel='manifest']");
  if (m) { m.href = `${API}/api/identidade/manifest?v=${s.versao}`; m.setAttribute("crossorigin", "anonymous"); }
}

export async function carregarIdentidade() {
  try {
    const r = await fetch(`${API}/api/identidade/publico`);
    estado = r.ok ? await r.json() : PADRAO;
  } catch { estado = PADRAO; }
  aplicarCores(estado.cores);
  aplicarFavicon(estado);
  subs.forEach((f) => f(estado));
  return estado;
}

/** Identidade visual vigente (cores + imagens do ADM). `src(tipo, fallback)` devolve a URL da imagem personalizada ou o asset padrão. */
export function useIdentidade() {
  const [s, setS] = useState(estado);
  useEffect(() => {
    subs.add(setS);
    if (!carregando) carregando = carregarIdentidade();
    return () => subs.delete(setS);
  }, []);
  const src = (tipo, fallback) => (s.imagens?.[tipo] ? urlArquivo(tipo, s.versao) : fallback);
  return { ...s, src, recarregar: carregarIdentidade };
}
